import { render } from "./MFITTExchangedTicketChangeCaution.vue?vue&type=template&id=a9b95d20"
import script from "./MFITTExchangedTicketChangeCaution.vue?vue&type=script&lang=js"
export * from "./MFITTExchangedTicketChangeCaution.vue?vue&type=script&lang=js"

import "./MFITTExchangedTicketChangeCaution.vue?vue&type=style&index=0&id=a9b95d20&lang=scss"
script.render = render

export default script